export default "__VITE_ASSET__9XnB$Bi$__"